module.exports = __webpack_public_path__ + "static/gallery17-3be8e09ad78437f496cd68c88a1b430e.jpg";